import React from 'react';

const resources = [
  {
    title: 'HCI Paper Publishing Decider',
    description:
      'A Codex skill for assessing an HCI manuscript by its contribution, maturity, reviewer fit, and submission readiness—then choosing a calibrated journal strategy.',
    type: 'Codex skill',
    format: 'Markdown',
    href: '/myskills/hci-paper-publishing-decider/SKILL.md',
  },
];

const Resources: React.FC = () => {
  return (
    <section className="mx-auto max-w-4xl py-8 sm:py-16" aria-labelledby="resources-heading">
      <header className="mb-14 max-w-2xl sm:mb-20">
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-gray-500">
          A growing collection
        </p>
        <h1
          id="resources-heading"
          className="mb-5 text-5xl font-semibold leading-none tracking-[-0.04em] text-gray-950 sm:text-7xl"
        >
          Resources
        </h1>
        <p className="max-w-xl text-lg leading-relaxed text-gray-600 sm:text-xl">
          Tools and references I think are worth sharing. Each one includes a short note on what it can help you do.
        </p>
      </header>

      <ol className="border-b border-gray-300">
        {resources.map((resource, index) => (
          <li
            key={resource.href}
            className="grid gap-5 border-t border-gray-300 py-8 sm:grid-cols-[3rem_minmax(0,1fr)_auto] sm:gap-8 sm:py-10"
          >
            <span className="text-sm tabular-nums text-gray-400" aria-hidden="true">
              {String(index + 1).padStart(2, '0')}
            </span>

            <div>
              <h2 className="mb-3 text-2xl font-semibold tracking-[-0.02em] text-gray-950 sm:text-3xl">
                {resource.title}
              </h2>
              <p className="mb-5 max-w-2xl text-base leading-relaxed text-gray-600 sm:text-lg">
                {resource.description}
              </p>
              <div className="flex flex-wrap gap-x-4 gap-y-2 text-xs font-medium uppercase tracking-[0.12em] text-gray-500">
                <span>{resource.type}</span>
                <span aria-hidden="true">·</span>
                <span>{resource.format}</span>
              </div>
            </div>

            <div className="sm:pt-1">
              <a
                href={resource.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex min-h-11 items-center gap-2 border-b border-black pb-1 text-sm font-semibold text-black transition-colors duration-200 hover:border-gray-400 hover:text-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
              >
                View skill
                <svg
                  aria-hidden="true"
                  viewBox="0 0 20 20"
                  fill="none"
                  className="h-4 w-4 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                >
                  <path d="M5 15 15 5M7 5h8v8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default Resources;
